import React, { useState } from "react"
import  "../AnbarGardaniStyle.css";

const SuccessModal=(props)=>{
    
    return(
        <React.Fragment>
          
<div className="location_modal text-right">
<div className="location_modal_box">
    <div className="location_modal_header bg-dark p-2">
<span className=" w-100 text-right text-white">پیغام </span>
    </div>
    <div className="p-4 text-center">
<p>
    عملیات با موفقیت انجام شد !
</p>
<p>
</p>
<hr />
<div className="row text-right my-3 " style={{direction:"rtl"}}>
    <div className="col-sm-12 text-sm-left">
    <button className="btn btn-success w-100" onClick={props.apply}>تایید</button>
    </div>
    
    </div>
    </div>
   

</div> 
</div> 
            </React.Fragment>
        )
}
export default SuccessModal;